import script from "./TopCatg.vue?vue&type=script&setup=true&lang=js"
export * from "./TopCatg.vue?vue&type=script&setup=true&lang=js"

import "./TopCatg.vue?vue&type=style&index=0&id=111a56e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111a56e0"]])

export default __exports__